var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    d: "M1.02388 14.431L4.38721 11.859C4.1949 11.2749 4.09091 10.65 4.09091 10C4.09091 9.35004 4.1949 8.72516 4.38721 8.14105L1.02388 5.56909C0.367906 6.90275 0 8.40634 0 10C0 11.5937 0.367906 13.0973 1.02388 14.431Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_2",
    d: "M4.38721 8.14102C5.1632 5.78407 7.37725 4.09091 10 4.09091C11.4091 4.09091 12.6818 4.59091 13.6818 5.40909L16.5909 2.5C14.8182 0.954545 12.5455 0 10 0C6.04824 0 2.65045 2.2621 1.02388 5.56906L4.38721 8.14102Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M9.99999 19.9999C6.04713 19.9999 2.64856 17.7366 1.02252 14.4281L4.38448 11.8506C5.15801 14.2119 7.37417 15.909 9.99999 15.909C11.2849 15.909 12.4234 15.6064 13.325 15.0374L16.5179 17.5094C14.7701 19.1346 12.4391 19.9999 9.99999 19.9999Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_3",
    d: "M10 8.18188H19.3182C19.4545 8.77279 19.5455 9.40916 19.5455 10.0001C19.5455 13.2594 18.3531 15.8033 16.5179 17.5096L13.325 15.0376C14.369 14.3787 15.0953 13.3626 15.3636 12.0455H10V8.18188Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.38f635ff1a41fb059abb56dffcfa64c2.svg";
export { ForwardRef as ReactComponent };